import { render } from "./ReferralDocuments.vue?vue&type=template&id=406a19fc&ts=true"
import script from "./ReferralDocuments.ts?vue&type=script&lang=ts&external"
export * from "./ReferralDocuments.ts?vue&type=script&lang=ts&external"

import "./ReferralDocuments.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__